import { IAdditionalSettings } from "@/config/additionalSettings.config";

const ukraineAdditionalSettingsConfig: IAdditionalSettings = {
  hasOSBB: true,
};

export default ukraineAdditionalSettingsConfig;
